import { connect } from 'react-redux';
import { IState } from '../../../../../store/types';
import { getAudioById } from '../../../../../store/models/selectors';
import { TAudioType } from '../../../../../store/models/types';
import { getCurrentAudioId } from '../../../../../store/current-video/selectors';
import { isProgressLogActive } from '../../../../../../common/utils/conferenceProgress';
import { RecordingActions } from '../components/RecordingActions';
import { IRecordingActionsEvents, IRecordingActionsFields } from '../components/types';
import { RecordingActionsEvents } from './events';

const mapStateToProps = (
  state: IState
): IRecordingActionsFields => {
  const audioId = getCurrentAudioId(state);
  const audio = audioId ? getAudioById(state, audioId) : null;
  return {
    hasCaptions: audio?.captionsCount !== 0, // as on the tile: unknown counts as present
    isProcessing: isProgressLogActive(audio?.progressLog || []),
    isCallUnprocessed: audio?.type === TAudioType.CONFERENCE, // nothing to download yet

  };
}

const mapDispatchToProps = (
  dispatch: any
): IRecordingActionsEvents => ({
  onDownload: () => dispatch(RecordingActionsEvents.onDownload()),
  onDownloadCaptions: () => dispatch(RecordingActionsEvents.onDownloadCaptions()),
  onDownloadCaptionsWithTimecodes: () => dispatch(RecordingActionsEvents.onDownloadCaptionsWithTimecodes()),
  onDelete: (forEveryone) => dispatch(RecordingActionsEvents.onDelete(forEveryone)),
});

export const RecordingActionsHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(RecordingActions);

RecordingActionsHOC.displayName = 'RecordingActionsHOC';
